import React from "react";

import { Colors } from "@zapier/design-system";

import SensitiveData from "@zapier/payment/esm/components/SensitiveData";
import { HostedFieldType, HostedFieldValue } from "@zapier/payment/esm/types";

import { getHostedFieldId } from "../utils";

type Props = {
  /** Show error styling */
  hasError: boolean;
  /** Call when field changes value */
  onChange: (value: HostedFieldValue) => void;
  /** Field type to show */
  type: HostedFieldType;
};

const Styles = {
  container: (props: Props) =>
    ({
      alignItems: "center",
      background: "none",
      borderRadius: 3,
      border: `1px solid ${
        props.hasError ? Colors.error500 : Colors.neutral600
      }`,
      boxSizing: "content-box",
      display: "flex",
      height: 24,
      overflow: "hidden",
      padding: "9px 15px",
      "> *": {
        flex: "0 0 100%",
      },
    } as const),
};

const HostedField: React.FC<Props> = props => {
  return (
    <div css={[Styles.container(props)]}>
      <SensitiveData>
        <div id={getHostedFieldId(props.type)} />
      </SensitiveData>
    </div>
  );
};

export default HostedField;
